import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'lovers-popup',
  templateUrl: './popup.component.html',
  styleUrls: ['./popup.component.scss'],
})
export class PopupComponent implements OnInit {
  @Input() public exibir: boolean = false;
  @Input() public exibirBotaoFechar: boolean = true;
  @Input() public tamanho: string = 'normal';
  @Input() public exibirBackground: boolean = false;
  @Input() public blockOverflow: boolean = false;
  @Output() public onClose: EventEmitter<null> = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}

  public fechar(): void {
    this.exibir = false;
    this.onClose.emit();
  }

  public definirClasse(): string {
    let classe: string = '';

    if (this.exibirBackground) classe += 'lovers-background ';

    switch (this.tamanho) {
      case 'pequeno2':
        classe += 'popup--very--small ';
        break;
      case 'pequeno':
        classe += 'popup--small ';
        break;
      case 'grande':
        classe += 'popup--biggest ';
        break;
      case 'auth':
        classe += 'popup--auth ';
        break;
      case 'desafio':
        classe += 'popup--desafio ';
        break;
      case 'imagem':
        classe += 'popup--imagem ';
        break;
    }

    if (this.blockOverflow) classe += 'popup--block--overflow ';

    return classe;
  }

  pararPropagacao(event: Event) {
    event.stopPropagation();
  }
}
